import { createImg } from "../../../DomUtilities/ElementsCreator";
import Variant from "../../../Models/Variant";
import Mediator from "../../../Utilities/Mediator";
import DescriptionModal from "./Modals/DescriptionModal";
import OrderHandler from "../OrderHandler";

export default class VariantTile {
	variant: Variant;
	variantTile: HTMLDivElement;
	descriptionIcon: HTMLElement;
	descriptionModal: DescriptionModal;

	constructor(variantObject: Variant) {
		this.variant = variantObject;
		this.descriptionModal = new DescriptionModal();

		this.init();
	}

	private init() {
		this.createVariantTile();
		this.addDescriptionModalClickListener();
		Mediator.on("variantRemoved", (id: string) => {
			if (id == this.variant.id) {
				this.variantTile.classList.remove('--selected');
			}
		});
	}

	private createVariantTile() {
		this.variantTile = document.createElement('div');
		this.descriptionIcon = document.createElement('i');
		const src: string = this.variant.image ? this.variant.image : "/assets/no_image_placeholder.png";
		const icon = createImg(src, `${this.variant.name} ikon`);
		const iconWrapper = document.createElement('div');
		const name = document.createElement('span');
		const cost = document.createElement('span');

		this.variantTile.id = this.variant.id;
		this.descriptionIcon.classList.add('icon-info-sign');
		iconWrapper.appendChild(icon);
		name.innerText = name.title = this.variant.name;
		cost.innerText = `${this.variant.cost} DKK`;

		this.variantTile.appendChild(this.descriptionIcon);
		this.variantTile.appendChild(iconWrapper);
		this.variantTile.appendChild(name);
		this.variantTile.appendChild(cost);

		if (OrderHandler.selectedItem.services.some(s => s.variants.some(v => v.id == this.variant.id))) {
			this.variantTile.classList.add('--selected');
		}
	}

	private addDescriptionModalClickListener() {
		this.descriptionIcon.onclick = (event: MouseEvent) => {
			event.stopPropagation();

			const text = this.variant.descriptions.find(d => d)?.text;
			const image = this.variant.descriptions.find(d => d)?.image;

			this.descriptionModal.openModal(text, image);
		}
	}
}
